import App from 'app/app.js';
import 'app/service/EventService.js';

function EmptyCartAction(EventService) {
  this.eventName = 'emptyCart';

  this.dispatch = function () {
    EventService.dispatch(this.eventName, {});
  };

  this.register = function (listener) {
    return EventService.register(this.eventName, listener);
  };
}

App.service('EmptyCartAction', ['EventService', EmptyCartAction]);
